export default "__VITE_ASSET__B$ikjFjO__"